import { TFunction } from 'i18next';

export const formatFamilyName = (name: string, t: TFunction, key: string = 'families.familyName'): string => {
  if (!name) return '';

  const suffix = ' Family';
  if (name.endsWith(suffix)) {
    const baseName = name.slice(0, -suffix.length);
    return t(key, { name: baseName });
  }

  return name;
};
